import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import QoSDashboard from './QoSDashboard';
import AdminDashboard from './AdminDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QoSDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;